"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clone = exports.isObject = void 0;
const isObject = (obj) => obj !== null && !Array.isArray(obj) && typeof obj === 'object';
exports.isObject = isObject;
const clone = (obj) => JSON.parse(JSON.stringify(obj));
exports.clone = clone;
